import React from 'react';

// Components
import AuthWrapper from 'Webapp/shared/app/components/auth/wrapper';
import SignupForm from 'Webapp/shared/app/containers/auth/signup-form';
import { OnboardingFlow } from 'Webapp/enums';

import connector from 'Webapp/utils/connector';
import connectOnboardingFlow, {
  ConnectOnboardingFlowProps,
} from 'Webapp/shared/app/connectors/connectOnboardingFlow';

const Signup: React.FC<ConnectOnboardingFlowProps> = ({
  continueOnboardingFlow,
}) => (
  <AuthWrapper>
    <SignupForm
      redirectAfterAuth
      onComplete={() => {
        continueOnboardingFlow(OnboardingFlow.SIGNUP_LANDING);
      }}
    />
  </AuthWrapper>
);

export default connector<ConnectOnboardingFlowProps>(connectOnboardingFlow)(
  Signup,
);
